import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

/**
 * Report tables build their period columns per response, so a saved view only
 * pins the fixed columns; filters carry the whole report parameter set.
 */
export enum SchedulesReportColumn {
    TITLE = "title",
    TERM_START = "termStart",
    TERM_END = "termEnd",
}

const TitleColumnSchema = ColumnSchema.extend({
    id: z.literal(SchedulesReportColumn.TITLE),
});
const TermStartColumnSchema = ColumnSchema.extend({
    id: z.literal(SchedulesReportColumn.TERM_START),
});
const TermEndColumnSchema = ColumnSchema.extend({
    id: z.literal(SchedulesReportColumn.TERM_END),
});
const PeriodColumnSchema = ColumnSchema.extend({
    id: z.string().regex(/^period-/),
});

export const SchedulesReportViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.SCHEDULES_REPORT),
    columns: z.array(
        z.union([
            TitleColumnSchema,
            TermStartColumnSchema,
            TermEndColumnSchema,
            PeriodColumnSchema,
        ]),
    ),
});

export type SchedulesReportView = z.infer<typeof SchedulesReportViewSchema>;
export type SchedulesReportViewFilters = SchedulesReportView["filters"];
